import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { NextBtn, BackBtn } from 'components/Shared/Button';
import { parseDate } from 'utils';
import { StepContainer } from './StepContainer';

const Success = ({ contract, handleBack, openDocument, source }) => {
  const { t } = useTranslation();
  return (
    <StepContainer
      className="sidebar-new-contract-height"
      title={t('contracts.new.done')}
      src={'/images/listing/createDocument/check.svg'}
      alt={t('common.checkmark')}
      form={
        <div className="text-center">
          <p className="font-weight-bold">{t('contracts.new.source_title')}</p>
          <p>{t(source)}</p>
          <p className="font-weight-bold">{t('contracts.new.name_title')}</p>
          <p>{contract.name}</p>
          <p className="font-weight-bold">{t('reports.tableHeaders.created')}</p>
          <p>{parseDate(new Date().toISOString(), 'P')}</p>
        </div>
      }
      footer={
        <>
          <BackBtn onClick={handleBack} label={t('form.exit')} />
          <NextBtn onClick={openDocument} label={t('contracts.new.ready')} />
        </>
      }
    />
  );
};

export default Success;
